import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import Footer from '../components/layout/Footer';

const RefundPolicy: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Hero Header Banner */}
      <div style={{ backgroundColor: '#0f172a', color: '#ffffff', padding: '32px 24px 48px', position: 'relative' }}>
        <div style={{ maxWidth: '960px', margin: '0 auto 16px auto', display: 'flex', alignItems: 'center' }}>
          <button
            onClick={() => window.history.length > 1 ? navigate(-1) : navigate('/')}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '8px 16px',
              borderRadius: '20px',
              backgroundColor: 'rgba(255, 255, 255, 0.12)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              color: '#ffffff',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              backdropFilter: 'blur(8px)',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.25)')}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.12)')}
          >
            <FiArrowLeft size={18} />
            Back
          </button>
        </div>
        <div style={{ textAlign: 'center' }}>
          <h1 style={{ fontSize: '32px', fontWeight: '900', margin: '0 0 12px 0', letterSpacing: '-0.5px' }}>
            Cancellation & Refund Policy
          </h1>
          <p style={{ fontSize: '15px', color: '#94a3b8', margin: 0, maxWidth: '600px', marginLeft: 'auto', marginRight: 'auto' }}>
            Transparent details on order cancellations, returns, and refund timelines at HoneyCool.
          </p>
        </div>
      </div>

      {/* Main Legal Content */}
      <div style={{ maxWidth: '960px', margin: '36px auto', padding: '0 24px', flex: 1, width: '100%', boxSizing: 'border-box' }}>
        <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', padding: '36px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)', textAlign: 'left' }}>
          
          <div style={{ marginBottom: '28px' }}>
            <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#1e293b', marginTop: 0, marginBottom: '12px', borderBottom: '2px solid #38bdf8', paddingBottom: '8px', display: 'inline-block' }}>
              1. Order Cancellation
            </h2>
            <p style={{ fontSize: '14px', color: '#475569', lineHeight: '1.7', margin: 0 }}>
              Customers can cancel an order directly from the <strong>My Orders</strong> drawer before the item status changes to <em>Shipped</em> or <em>Out for Delivery</em>. Once an order is dispatched, standard return guidelines apply.
            </p>
          </div>

          <div style={{ marginBottom: '28px' }}>
            <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#1e293b', marginTop: 0, marginBottom: '12px', borderBottom: '2px solid #38bdf8', paddingBottom: '8px', display: 'inline-block' }}>
              2. Eligibility for Returns & Replacement
            </h2>
            <p style={{ fontSize: '14px', color: '#475569', lineHeight: '1.7', margin: '0 0 12px 0' }}>
              Returns or product replacements are accepted within <strong>7 days</strong> of delivery if:
            </p>
            <ul style={{ fontSize: '14px', color: '#475569', lineHeight: '1.7', margin: 0, paddingLeft: '20px' }}>
              <li>The delivered product is damaged, defective, or physically broken during transit.</li>
              <li>Incorrect product model, valve specification, or copper roll size was shipped.</li>
              <li>Items are returned with original tags, tax invoices, and unbroken protective seals.</li>
            </ul>
          </div>

          <div style={{ marginBottom: '28px' }}>
            <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#1e293b', marginTop: 0, marginBottom: '12px', borderBottom: '2px solid #38bdf8', paddingBottom: '8px', display: 'inline-block' }}>
              3. Refund Processing & Timelines
            </h2>
            <p style={{ fontSize: '14px', color: '#475569', lineHeight: '1.7', margin: 0 }}>
              Once returned items pass quality inspection at our central warehouse, refunds are initiated immediately to the original payment source (UPI, Credit/Debit Card, Net Banking) within <strong>3-5 business days</strong>.
            </p>
          </div>

          <div style={{ marginBottom: '0' }}>
            <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#1e293b', marginTop: 0, marginBottom: '12px', borderBottom: '2px solid #38bdf8', paddingBottom: '8px', display: 'inline-block' }}>
              4. Support Desk
            </h2>
            <p style={{ fontSize: '14px', color: '#475569', lineHeight: '1.7', margin: 0 }}>
              For refund assistance, please email <strong>refunds@honeycool.com</strong> or call <strong>1800-3000-2434</strong>.
            </p>
          </div>

        </div>
      </div>

      <Footer />
    </div>
  );
};

export default RefundPolicy;
